import { useState, useEffect } from 'react';
import './SuccessPage.css';  // Don't forget to import your CSS file
import { initFacebookPixel } from '../facebookPixel';
const SuccessPage = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const paymentStatus = sessionStorage.getItem('paymentStatus');
    const savedMessage = sessionStorage.getItem('message');

    if (paymentStatus === 'success') {
      setMessage(savedMessage);
    }

    // Clear sessionStorage after showing the message
    sessionStorage.removeItem('paymentStatus');
    sessionStorage.removeItem('message');
  }, []);

  const handleConfirm = () => {
    window.location.href = '/';
  };

  const handleContactSupport = () => {
    window.open('https://wa.me/+919663979929?text=Hello%20Machaxi', '_blank');
    window.location.href = '/';
  };
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="success-page-container">
      <div className="success-message-container">
        <p className="success-message">{message}</p>
      </div>
      <div className="actions-container">
        <button className="go-home-button" onClick={handleConfirm}>Go to Home</button>
        <button className="contact-support-button" onClick={handleContactSupport}>Contact Support</button>
      </div>
    </div>
  );
};

export default SuccessPage;
